import React from 'react';
import { VideoType } from '../../../commonTypes/video';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { VideoContainer, VideoFrame } from './styles';
export type VideoProps = VideoType & ComponentProps;

const Video: React.FC<VideoProps> = ({
  src,
  screenReaderText,
  videoCookiePolicyData,
  ...props
}) => {
  //
  // See documentation about Optanon Cookie Categories further below
  //
  const isCookieConsentRequired = !!videoCookiePolicyData;
  const optanonClassName = `optanon-category-${videoCookiePolicyData?.optanonRequiredConsentCategories}`;
  const VideoCookieNotice = videoCookiePolicyData?.CookieNoticeComponent;

  return (
    <VideoContainer {...componentProps(props)}>
      <VideoFrame
        data-src={isCookieConsentRequired ? src : undefined}
        className={isCookieConsentRequired ? optanonClassName : undefined}
        src={isCookieConsentRequired ? undefined : src}
        title={screenReaderText}
        frameBorder="0"
        allow="picture-in-picture;"
        allowFullScreen
      />
      {VideoCookieNotice && <VideoCookieNotice />}
    </VideoContainer>
  );
};

export default Video;

// ------------------------------------------
// Documentation about Optanon Categories
// ------------------------------------------
//
// Some videos, like YouTube videos, place cookies in the browser.
// We need to require acceptance of such cookies from the user to enable
// the display and playback functionality of the videos.
//
// RSA Ticket References:
// https://jira2.uk.rsa-ins.com/browse/CDS-326
// https://jira2.uk.rsa-ins.com/browse/CDS-499
//
// The optanonRequiredConsentCategories prop indicates the Optanon categories of
// the cookies that we need the user to accept. As an example, for YouTube videos,
// the cookie category is "C0005" (Social Media cookies)
//
// If the optanonRequiredConsentCategories prop is populated, then we
// apply a solution provided by OneTrust
//
// OneTrust References:
// https://my.onetrust.com/s/article/UUID-3dc06342-ff6b-3578-5024-6d7c05d03283?language=en_US
// https://my.onetrust.com/s/article/UUID-8102e851-d860-d465-d8d6-b1d636d68eb9
//
// Confluence reference:
// See https://confluence2.uk.rsa-ins.com/pages/viewpage.action?pageId=254315584
//
